import { IconButton, Tooltip } from '@chakra-ui/react';
import { IconEditBig } from 'central-icons/IconEditBig';
import mixpanel from 'mixpanel-browser';
import type { FC } from 'react';

import { BuildADashTrackingEvents, FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';

interface ViewModeButtonsProps {
  isOwner: boolean;
  onSetEditMode: () => void;
  pageId: string;
}

export const ViewModeButtons: FC<ViewModeButtonsProps> = ({
  isOwner,
  onSetEditMode,
  pageId,
}) => {
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);
  return (
    <Tooltip
      label={isOwner ? 'Edit Page' : 'Copy and Edit Page'}
      openDelay={300}
      variant="label"
      hasArrow
    >
      <IconButton
        colorScheme="gray"
        {...(isNewDashboardLayout ? { variant: 'flat' } : { bg: 'gray.200' })}
        rounded="full"
        onClick={() => {
          onSetEditMode();
          if (isOwner) {
            mixpanel.track(BuildADashTrackingEvents.EDIT_PAGE, {
              page_id: pageId,
            });
          } else {
            mixpanel.track(BuildADashTrackingEvents.CLONE_PAGE, {
              page_id: pageId,
            });
          }
        }}
        aria-label="Edit Page"
        icon={<IconEditBig size={16} />}
      />
    </Tooltip>
  );
};
